import { z } from "zod";
import { nonEmptyString } from "@/utils/form";
import { provinces } from "@/constants/provinces";
import { t } from "i18next";

const provinceCodes = provinces.map(province => province.code) as [string, ...string[]];

// Define the Site schema
export const SiteSchema = z.object({
  name: nonEmptyString("Site Name"),
  address: nonEmptyString("Address"),
  province: z.enum(provinceCodes, {
    message: t("schemas:site.provincerequired"),
  }),
  city: nonEmptyString("City"),
  country: nonEmptyString("Country"),
  postalCode: z.string().min(1, t("schemas:site.postalcoderequired")),
});

export const SiteDefaultValues = {
  name: "",
  address: "",
  province: "",
  city: "",
  country: "",
  postalCode: "",
};

export type TSiteSchema = z.infer<typeof SiteSchema>;
